// extracted by mini-css-extract-plugin
export default {"LoaderParent":"LoaderComponent_LoaderParent__06eZe"};